var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.5,
    r: 11.5,
    fill: "#28293D",
    stroke: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1775_15715)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.59766 15.6511V17.9011H8.84766L15.4837 11.2651L13.2337 9.01511L6.59766 15.6511ZM17.2237 9.52511C17.4577 9.29111 17.4577 8.91311 17.2237 8.67911L15.8197 7.27511C15.5857 7.04111 15.2077 7.04111 14.9737 7.27511L13.8757 8.37311L16.1257 10.6231L17.2237 9.52511Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1775_15715"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.4,
    height: 14.4,
    fill: "white",
    transform: "translate(4.79688 5.30103)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.1b6af32442fe3300cae8dd187e6063a6.svg";
export { ForwardRef as ReactComponent };